export default __webpack_public_path__ + "static/our-team-grid-2075af9211fa312dc52ca86b052fcd6f.png";